import ActionButton from 'components/ActionButton';
import React, { useEffect, useState } from 'react';
import styles from './index.module.scss';
import qs from 'query-string';

const Filter = props => {
  const [status, setStatus] = useState<string>('');
  const [routeId, setRouteId] = useState<string>('');

  useEffect(() => {
    const {
      status,
      routeId,
    } = qs.parse(props.location.search, { parseBooleans: true, parseNumbers: true });

    setStatus(status?.toString() || '');
    setRouteId(routeId?.toString() || '');
  }, []);


  const resetFilter = () => {
    setStatus('');
    setRouteId('');

    const filterData = {
      status: '',
      routeId: '',
    };
    props.onSubmit(filterData);
  };

  const handleSubmit = () => {
    if (routeId) {
      props.history.push(`/routes/${routeId}`);
    } else {
      const filterData = {
        status,
        routeId,
      };
      props.onSubmit(filterData);
    }
  };

  return (
    <form className={styles['filter-container']} onSubmit={handleSubmit}>
      <div className={styles['input-container']}>
        <div className={styles['input-group']}>
          <div className={styles['label']}>Status</div>
          <select
            value={status}
            className={'form-control'}
            onChange={e => setStatus(e.target.value)}
          >
            <option hidden={!!status} value={'default'}>Select a status</option>
            <option value={'ASSIGNED'}>ASSIGNED</option>
            <option value={'DELIVERED'}>DELIVERED</option>
            <option value={'PENDING'}>PENDING</option>
          </select>
        </div>
        <div className={styles['input-group']}>
          <div className={styles['label']}>Route ID</div>
          <input
            value={routeId}
            className={'form-control'}
            onChange={e => setRouteId(e.target.value)}
          />
        </div>
      </div>
      <div className={styles['buttons-container']}>
        <ActionButton
          text={'Reset'}
          active={true}
          isLoading={false}
          onClick={resetFilter}
        />
        <ActionButton
          text={'Submit'}
          active={true}
          isSubmit={true}
          isLoading={false}
          onClick={handleSubmit}
        />
      </div>
    </form>
  );
};

export default Filter;